import {useNavigate} from "react-router-dom";
import {MappedJob} from "../../store/services/jobApi";
import {prettyEnum} from "./utils";

/**
 * Jobs have no banner image in the backend, so each card falls back to an
 * energy-themed photo chosen from the job's tags (stable per job id).
 */
const BANNERS = [
    {photo: "/public/sections/job_solar.jpg", label: "Solar Energy", color: "#1A822A", match: ["solar", "pv", "photovoltaic"]},
    {photo: "/public/sections/job_power.jpg", label: "Power Systems", color: "#F26722", match: ["electric", "power", "grid", "transmission"]},
    {photo: "/public/sections/job_mobility.jpg", label: "Mobility", color: "#2E9BDE", match: ["ev", "charging", "mobility", "vehicle"]},
    {photo: "/public/sections/job_renewable.jpg", label: "Renewable Energy", color: "#3FA34D", match: ["wind", "renewable", "project", "hydro"]},
];

const pickBanner = (job: MappedJob) => {
    const haystack = [job.title, ...(job.tags ?? [])].join(" ").toLowerCase();
    const matched = BANNERS.find((b) => b.match.some((m) => haystack.includes(m)));
    if (matched) return matched;

    // Stable fallback so a job always keeps the same banner between renders.
    const seed = String(job.id).split("").reduce((sum, c) => sum + c.charCodeAt(0), 0);
    return BANNERS[seed % BANNERS.length];
};

export const PublicJobCard = ({job}: {job: MappedJob}) => {
    const navigate = useNavigate();
    const banner = pickBanner(job);
    const companyName = job.company?.name?.trim();
    const showCompany = Boolean(companyName) && companyName!.toLowerCase() !== job.title.trim().toLowerCase();

    return (
        <div className="oec-job-card">
            <div className="oec-job-card-media">
                <img src={banner.photo} alt="" loading="lazy"/>
                <span className="oec-job-card-chip" style={{backgroundColor: banner.color}}>
                    {banner.label}
                </span>
            </div>

            <div className="oec-job-card-body">
                <h3 className="oec-job-card-title">{job.title}</h3>
                {showCompany && (
                    <p className="oec-job-card-meta">
                        <i className="fas fa-industry"/>
                        <span>{companyName}</span>
                    </p>
                )}

                <p className="oec-job-card-meta">
                    <i className="fas fa-map-marker-alt"/>
                    <span>{job.location}</span>
                </p>
                <p className="oec-job-card-meta">
                    <i className="far fa-clock"/>
                    <span>{prettyEnum(job.employmentType)}</span>
                </p>

                <button className="oec-card-btn" onClick={() => navigate(`/job/${job.id}`)}>
                    View Job <i className="fas fa-arrow-right"/>
                </button>
            </div>
        </div>
    );
};
